import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const GlobalSyncBanner = () => {
  const { syncInBackground } = useAuth();

  if (!syncInBackground) return null;

  return (
    <div className="sticky top-16 z-50 w-full bg-gradient-to-r from-indigo-600/90 to-purple-600/90 backdrop-blur-sm text-white text-center py-1.5 px-4 text-xs sm:text-sm font-medium flex items-center justify-center gap-2 shadow-lg">
      <Loader2 className="w-3.5 h-3.5 animate-spin" />
      <span>Syncing with SAP in background…</span>
      <Loader2 className="w-3.5 h-3.5 animate-spin" />
    </div>
  );
};

export default GlobalSyncBanner;
